// constants.ts
export const NAME = 'patientProfile';